import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: 48,
        maxWidth: 1248,
        margin: 'auto'
    },
    links: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: 16,
        '& a': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: theme.palette.text.primary,
            fontWeight: 500
        }
    },
    more: {
        marginTop: 48,
        fontSize: 24,
        fontWeight: 600
    },
    paging: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: 48,
        gap: 16,
        '& a': {
            color: theme.palette.text.primary,
            fontWeight: 500
        }
    }
}));
